import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(items: any[], field: string, value: string) {

  
    if (!items) return [];
    if (!value) return items;
    return items.filter(function (commercant: any) {
      return commercant.denomination.toUpperCase().includes(value.toUpperCase())
     });
 
      
  }
}
